
import { useState, FormEvent } from 'react';

export default function BlogNewsletter() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (!email.trim()) return;

    setStatus('loading');
    try {
      const formData = new URLSearchParams();
      formData.append('email', email);

      const res = await fetch('https://readdy.ai/api/form/d6cisbitehdqnvnpiesg', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: formData.toString(),
      });

      if (res.ok) {
        setStatus('success');
        setEmail('');
      } else {
        setStatus('error');
      }
    } catch {
      setStatus('error');
    }
  };

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="relative rounded-2xl overflow-hidden">
          <div className="absolute inset-0">
            <img
              src="https://public.readdy.ai/ai/img_res/90913ca17679ad4a08ad8ed7c8112b33.jpg"
              alt="Newsletter background"
              className="w-full h-full object-cover object-top"
            />
          </div>
          <div className="absolute inset-0 bg-[#1B5E20]/85"></div>
          <div className="relative z-10 py-16 px-12 text-center">
            <div className="w-12 h-12 mx-auto mb-5 rounded-full bg-white/20 flex items-center justify-center">
              <i className="ri-mail-send-line text-xl text-white"></i>
            </div>
            <h4 className="text-3xl font-serif text-white mb-3">
              <a href="/blog" className="text-white hover:text-[#A5D6A7] transition-colors">Stay Inspired</a>
            </h4>
            <p className="text-white/80 text-sm mb-8 max-w-md mx-auto">
              Get the latest beauty tips, fragrance guides, and exclusive offers delivered to your inbox every week.
            </p>
            <form
              id="blog-newsletter-form"
              data-readdy-form
              onSubmit={handleSubmit}
              className="flex items-center gap-3 max-w-md mx-auto"
            >
              <input
                type="email"
                name="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Enter your email"
                required
                className="flex-1 px-5 py-3.5 rounded-full bg-white/15 border border-white/30 text-white text-sm placeholder-white/50 focus:outline-none focus:border-white transition-colors"
              />
              <button
                type="submit"
                disabled={status === 'loading'}
                className="px-7 py-3.5 rounded-full bg-white text-[#1B5E20] text-sm font-semibold hover:bg-[#A5D6A7] transition-colors cursor-pointer whitespace-nowrap disabled:opacity-60"
              >
                {status === 'loading' ? 'Sending...' : 'Subscribe'}
              </button>
            </form>
            {status === 'success' && (
              <p className="text-[#A5D6A7] text-sm mt-4">Thank you! You&apos;re now subscribed.</p>
            )}
            {status === 'error' && (
              <p className="text-red-300 text-sm mt-4">Something went wrong. Please try again.</p>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}
